/**
 * @generated SignedSource<<e00e81f580184c909163b0cb1b4aa4e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeroCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_user" | "PdpRespSharedHeroCarousel_user">;
  readonly " $fragmentType": "PdpRespUnavailableHeroCarousel_user";
};
export type PdpRespUnavailableHeroCarousel_user$key = {
  readonly " $data"?: PdpRespUnavailableHeroCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeroCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeroCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cb0e2dd326b80b7aec849f94d8424046";

export default node;
